var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 12.75V1.5C0.25 1.15625 0.3725 0.861876 0.6175 0.616876C0.8625 0.371876 1.15667 0.249584 1.5 0.250001H11.5C11.8438 0.250001 12.1381 0.372501 12.3831 0.617501C12.6281 0.862501 12.7504 1.15667 12.75 1.5V9C12.75 9.34375 12.6275 9.63813 12.3825 9.88313C12.1375 10.1281 11.8433 10.2504 11.5 10.25H2.75L0.25 12.75Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.5d21ffa0b467ea5f44332f2c901f0afd.svg";
export { ForwardRef as ReactComponent };